module.exports = __webpack_public_path__ + "img/icon-close-red.80661e6a.svg";